import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import { Field, Formik, Form } from 'formik';
import { ComboBox, Button, LoadingIndicator, Checkbox } from '@components';
import {
  QuestionarioPerfilInvestidorSchema,
  QuestionarioPerfilInvestidorValues,
} from '@schemas';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// import { Checkbox } from '@mui/material';
import { perguntas } from './perguntas/lista-perguntas';
import { formataResultado } from './util/formata-resultado';
import {
  obtemMaiorValorQ5,
  somaValorQuestionario,
} from './util/soma-total-questionario';
import { validaCheckboxQ5, validaEtapas } from './util/valida-etapas';
import { QuestionarioPerfilInvestimentoService } from '../../../../common/services';
import { ResultadoQuestionario } from './telaResultado';

const steps = ['1', '2'];

export const PerfilQuestionario = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [validaEtapa, setValidaEtapa] = useState(false);
  const [loading, setLoading] = useState(false);
  const [skipped, setSkipped] = useState(new Set());
  const custom = useSelector((state) => state.customizaSistema);
  const users = useSelector((state) => state.user);
  const navigate = useNavigate();

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, [activeStep]);

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
    setValidaEtapa(false);
  };

  const handleBack = () => {
    if (activeStep === 0) {
      navigate(-1);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleSubmitService = async (values) => {
    const questionarioService = new QuestionarioPerfilInvestimentoService();
    const resultadoJson = formataResultado(values);
    await questionarioService.setResultadoQuestionario(
      users.matricula,
      somaValorQuestionario(values),
      resultadoJson,
      users.token
    );
    setLoading(false);
    handleNext();
  };

  return !loading ? (
    <div className="card">
      <div className="card-content mt-32">
        <Box sx={{ width: '100%' }}>
          <Stepper activeStep={activeStep}>
            {steps.map((label, index) => {
              const stepProps = {};
              const labelProps = {};
              if (isStepSkipped(index)) {
                stepProps.completed = false;
              }
              return (
                <Step
                  key={label}
                  sx={{
                    '& .MuiStepLabel-root .Mui-completed': {
                      color: '#EB943C',
                    },
                    '& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel':
                      {
                        color: 'grey.500',
                      },
                    '& .MuiStepLabel-root .Mui-active': {
                      color: '#EB943C',
                    },
                    '& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel':
                      {
                        color: 'common.white',
                      },
                    '& .MuiStepLabel-root .Mui-active .MuiStepIcon-text': {
                      fill: 'black',
                    },
                    marginLeft: '25px',
                    marginRight: '25px',
                  }}
                  {...stepProps}
                >
                  <StepLabel {...labelProps} />
                </Step>
              );
            })}
          </Stepper>
          {activeStep === steps.length ? (
            <Typography sx={{ mt: 2, mb: 1 }}>
              <div className="row">
                <div className="col-8">
                  <ResultadoQuestionario matricula={users.matricula} />
                </div>
                <div className="col-3 hstack">
                  <Button onClick={handleReset}>Simular novamente</Button>
                </div>
              </div>
            </Typography>
          ) : (
            <div className="row mt-32">
              <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                <Formik
                  validateOnMount
                  initialValues={QuestionarioPerfilInvestidorValues}
                  validationSchema={QuestionarioPerfilInvestidorSchema}
                  onSubmit={async (values) => {
                    // eslint-disable-next-line no-param-reassign
                    values.questao5 = obtemMaiorValorQ5(values);
                    setLoading(true);
                    await handleSubmitService(values);
                  }}
                >
                  {({ values, handleSubmit, isValid }) => (
                    <Form>
                      {setValidaEtapa(validaEtapas(values, activeStep))}
                      <div className="card-borderless">
                        <div className="card-body">
                          {perguntas.map((item, index) => {
                            const questaoName = `questao${index + 1}`;
                            return (
                              <div key={`${item.pergunta}`}>
                                {item.etapa === activeStep && (
                                  <div className="row">
                                    <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                                      <h3 className="ts-20 fw-bold mb-2">
                                        Questão {index + 1}
                                      </h3>
                                      <span className="mt-2 mb-2 px-3">
                                        {item.pergunta}
                                      </span>
                                      {item.tipo === 'ComboBox' && (
                                        <Field
                                          color={custom.nomeCorPrincipal}
                                          className="mb-3 col-12 mt-2 px-3"
                                          name={`questao${index + 1}`}
                                          component={ComboBox}
                                          options={item.opcoes.map((x) => {
                                            return {
                                              value: x.value,
                                              label: x.label,
                                            };
                                          })}
                                        />
                                      )}
                                      {item.tipo === 'checkbox' && (
                                        <>
                                          {item.opcoes.map((x, opcaoIndex) => {
                                            const questaoNameCheckbox = `${questaoName}_${
                                              opcaoIndex + 1
                                            }`;
                                            return (
                                              <div
                                                className="row mt-3 align-items-center px-3"
                                                key={x.value}
                                              >
                                                <Field
                                                  component={Checkbox}
                                                  className="col-12 px-3"
                                                  name={questaoNameCheckbox}
                                                  value={x.value}
                                                  label={x.label}
                                                />
                                              </div>
                                            );
                                          })}
                                        </>
                                      )}
                                      <hr className="my-4" />
                                    </div>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          pt: 2,
                          marginTop: '0px',
                          marginLeft: '25px',
                          marginRight: '25px',
                          marginBottom: '25px',
                        }}
                      >
                        <div className="row">
                          <Button onClick={handleBack}>Voltar</Button>
                        </div>
                        <Box sx={{ flex: '1 1 auto' }} />
                        {activeStep === steps.length - 1 && (
                          <div className="row">
                            <Button
                              disabled={!isValid || !validaCheckboxQ5(values)}
                              onClick={handleSubmit}
                            >
                              Enviar
                            </Button>
                          </div>
                        )}

                        {activeStep !== steps.length - 1 && (
                          <div className="row">
                            <Button
                              onClick={handleNext}
                              disabled={!validaEtapa}
                            >
                              Próximo
                            </Button>
                          </div>
                        )}
                      </Box>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          )}
        </Box>
      </div>
    </div>
  ) : (
    <LoadingIndicator />
  );
};
